var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "208 -820.92 544 683.38",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-428q-51.54 0-87.77-36.23T356-552t36.23-87.77T480-676t87.77 36.23T604-552t-36.23 87.77T480-428m0-32q37.69 0 64.85-27.15Q572-514.31 572-552t-27.15-64.85Q517.69-644 480-644t-64.85 27.15Q388-589.69 388-552t27.15 64.85Q442.31-460 480-460m0 322.46q-116.54-33.77-194.27-139.54T208-515v-201.31l272-104.61 272 104.61V-515q0 132.15-77.73 237.92T480-137.54m0-648.69L240-695v180q0 59.15 17.69 113.77 17.69 54.61 49.85 99.92 39.92-19.23 82.96-28.96T480-340t89.5 9.73 82.96 28.96q32.16-45.31 49.85-99.92Q720-455.85 720-515v-180zM480-308q-41.38 0-79.85 7.77-38.46 7.77-73 24.08 30.54 37.15 69 64.38Q434.62-184.54 480-171q45.38-13.54 83.46-40.77t68.62-64.38q-34.54-16.31-72.62-24.08T480-308"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldPerson);
export default __webpack_public_path__ + "static/media/shield_person.f29be3a6bcc73c98e37b6d8bada3ffb8.svg";
export { ForwardRef as ReactComponent };